export default __webpack_public_path__ + "static/media/icon-cart.1589f603.png";